import assign from "lodash.assign";
import isEmpty from "lodash.isempty";
import Validation from "common/utils/Validation";
import {
    setErrorInErrors,
    clearErrorFromErrors,
    clearErrorsFromErrors
} from "../utils/errorsUtil";
import {
    ADDRESS_FIELDS,
    ADDRESS_VALIDATION_FIELDS,
    SUBSCRIPTION_FORM_SHIPPING_ADDRESS_FIELDS
} from "common/constants/Constants";
import { LOCATION_CHANGE } from "react-router-redux";
import REDUX_ERROR_TYPES from "constants/ReduxErrorTypes";

export const SHIPPING_ADDRESS_FORM_UPDATE_COUNTRY = "SHIPPING_ADDRESS_FORM_UPDATE_COUNTRY";
export const SHIPPING_ADDRESS_FORM_UPDATE_COUNTRY_AND_RESET = "SHIPPING_ADDRESS_FORM_UPDATE_COUNTRY_AND_RESET";
export const SHIPPING_ADDRESS_FORM_UPDATE_STATE = "SHIPPING_ADDRESS_FORM_UPDATE_STATE";
export const SHIPPING_ADDRESS_FORM_UPDATE_POSTALCODE = "SHIPPING_ADDRESS_FORM_UPDATE_POSTALCODE";
export const SHIPPING_ADDRESS_FORM_UPDATE_FIRST_NAME = "SHIPPING_ADDRESS_FORM_UPDATE_FIRST_NAME";
export const SHIPPING_ADDRESS_FORM_UPDATE_LAST_NAME = "SHIPPING_ADDRESS_FORM_UPDATE_LAST_NAME";
export const SHIPPING_ADDRESS_FORM_UPDATE_LINE_1 = "SHIPPING_ADDRESS_FORM_UPDATE_LINE_1";
export const SHIPPING_ADDRESS_FORM_UPDATE_LINE_2 = "SHIPPING_ADDRESS_FORM_UPDATE_LINE_2";
export const SHIPPING_ADDRESS_FORM_UPDATE_CITY = "SHIPPING_ADDRESS_FORM_UPDATE_CITY";
export const SHIPPING_ADDRESS_FORM_UPDATE_ADDRESS = "SHIPPING_ADDRESS_FORM_UPDATE_ADDRESS";
export const SHIPPING_ADDRESS_FORM_SHOW_ERROR = "SHIPPING_ADDRESS_FORM_SHOW_ERROR";
export const SHIPPING_ADDRESS_FORM_CLEAR_ERROR = "SHIPPING_ADDRESS_FORM_CLEAR_ERROR";
export const SHIPPING_ADDRESS_FORM_UPDATE_SHOW_MODAL = "SHIPPING_ADDRESS_FORM_UPDATE_SHOW_MODAL";
export const SUBSCRIPTION_FORM_CLEAR_ERROR = "SUBSCRIPTION_FORM_CLEAR_ERROR";

export function shippingAddressFormReducer(state = { errors: {} }, action) {
    switch (action.type) {
        case SHIPPING_ADDRESS_FORM_UPDATE_COUNTRY:
            return assign({}, state, {
                country: action.country
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_COUNTRY_AND_RESET:
            return assign({}, state, {
                country: action.country,
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                postalCode: ""
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_STATE:
            return assign({}, state, {
                state: action.state
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_POSTALCODE:
            return assign({}, state, {
                postalCode: action.postalCode
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_FIRST_NAME:
            return assign({}, state, {
                firstName: action.firstName
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_LAST_NAME:
            return assign({}, state, {
                lastName: action.lastName
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_LINE_1:
            return assign({}, state, {
                addressLine1: action.addressLine1
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_LINE_2:
            return assign({}, state, {
                addressLine2: action.addressLine2
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_CITY:
            return assign({}, state, {
                city: action.city
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_ADDRESS:
            return assign({}, state, {
                addressLine1: action.addressLine1,
                addressLine2: action.addressLine2,
                city: action.city,
                state: action.state,
                postalCode: action.postalCode,
                verifiedAddress: {
                    addressLine1: action.addressLine1,
                    addressLine2: action.addressLine2,
                    city: action.city,
                    state: action.state,
                    postalCode: action.postalCode,
                    country: state.country
                },
                errors: clearErrorsFromErrors(state.errors, [
                    "addressLine1",
                    "addressLine2",
                    "city",
                    "state",
                    "postalCode"
                ])
            });
        case SHIPPING_ADDRESS_FORM_SHOW_ERROR:
            return assign({}, state, {
                errors: setErrorInErrors(state.errors, action.error)
            });
        case SHIPPING_ADDRESS_FORM_CLEAR_ERROR:
            return assign({}, state, {
                errors: clearErrorFromErrors(state.errors, action.errorType)
            });
        case SHIPPING_ADDRESS_FORM_UPDATE_SHOW_MODAL:
            return assign({}, state, {
                showModal: action.showModal
            });
        case LOCATION_CHANGE:
            return assign({}, state, {
                showModal: false
            });
        default:
            return state;
    }
}

export function updateError(error, type) {
    return (dispatch, getState) => {
        if (!error) {
            const { errors = {} } = getState().shippingAddressForm;

            return errors[type] && dispatch(clearError(type));
        }

        dispatch(showError({ type, message: error.message }));
    };
}

export function validateShippingAddressForSubscription() {
    return (dispatch, getState) => {
        const {
            subscriptionForm: {
                selectedProductDetails: {
                    productType
                }
            }
        } = getState();

        const fields = SUBSCRIPTION_FORM_SHIPPING_ADDRESS_FIELDS[productType];

        if (!fields) {
            return false;
        }

        return dispatch(validateShippingAddress(fields));
    };
}

export function validateShippingAddress(fields) {
    return (dispatch, getState) => {
        const shippingAddressForm = getState().shippingAddressForm;

        fields.forEach((field) => dispatch(validateAndUpdate(field, shippingAddressForm[field])));

        const { errors } = getState().shippingAddressForm;

        return isEmpty(errors);
    };
}

export function verifyAddress() {
    return (dispatch, getState) => {
        const shippingAddressForm = getState().shippingAddressForm;
        const { verifiedAddress = {} } = shippingAddressForm;

        if (!shippingAddressForm.showModal
            && ADDRESS_VALIDATION_FIELDS.some(
                (field) => shippingAddressForm[field] !== verifiedAddress[field])
        ) {
            dispatch(updateShowModal(true));

            return false;
        }

        return true;
    };
}

export function validateAndUpdate(field, value) {
    return (dispatch) => {
        switch (field) {
            case ADDRESS_FIELDS.COUNTRY:
                return dispatch(validateAndUpdateCountry(value));
            case ADDRESS_FIELDS.STATE:
                return dispatch(validateAndUpdateState(value));
            case ADDRESS_FIELDS.POSTAL_CODE:
                return dispatch(validateAndUpdatePostalCode(value));
            case ADDRESS_FIELDS.CITY:
                return dispatch(validateAndUpdateCity(value));
            case ADDRESS_FIELDS.ADDRESS_LINE_1:
                return dispatch(validateAndUpdateAddressLine1(value));
            case ADDRESS_FIELDS.FIRST_NAME:
                return dispatch(validateAndUpdateFirstName(value));
            case ADDRESS_FIELDS.LAST_NAME:
                return dispatch(validateAndUpdateLastName(value));
        }
    };
}

export function validateAndUpdateCountry(country, option) {
    return (dispatch) => {
        const error = Validation.validateCountry(country);

        dispatch(updateCountry(country, option));
        dispatch(updateError(error, "country"));
    };
}

export function validateAndUpdateState(state) {
    return (dispatch, getState) => {
        const country = getState().shippingAddressForm.country;
        const error = Validation.validateStateOrProvince(country, state);

        dispatch(clearSubscriptionFormError(REDUX_ERROR_TYPES.CANCEL_NOTICE_UNCHECKED));
        dispatch(updateState(state));
        dispatch(updateError(error, "state"));
    };
}

export function validateAndUpdatePostalCode(postalCode) {
    return (dispatch, getState) => {
        const country = getState().shippingAddressForm.country;
        const error = Validation.validatePostalCode(country, postalCode);

        dispatch(updatePostalCode(postalCode));
        dispatch(updateError(error, "postalCode"));
    };
}

export function validateAndUpdateAddressLine1(addressLine1) {
    return (dispatch) => {
        dispatch(validateAddressLine1(addressLine1));
        dispatch(updateAddressLine1(addressLine1));
    };
}

export function validateAddressLine1(line1) {
    return (dispatch, getState) => {
        const addressLine1 = typeof line1 === "string"
            ? line1 : getState().shippingAddressForm.addressLine1;
        const error = Validation.validateFieldIsRequired(addressLine1)
            || Validation.validateEnglishCharacters(addressLine1);

        dispatch(updateError(error, "addressLine1"));
    };
}

export function validateAndUpdateAddressLine2(addressLine2) {
    return (dispatch) => {
        const error = Validation.validateEnglishCharacters(addressLine2);

        dispatch(updateAddressLine2(addressLine2));
        dispatch(updateError(error, "addressLine2"));
    };
}

export function validateAndUpdateCity(city) {
    return (dispatch) => {
        const error = Validation.validateFieldIsRequired(city)
            || Validation.validateEnglishCharacters(city);

        dispatch(updateCity(city));
        dispatch(updateError(error, "city"));
    };
}

export function validateAndUpdateFirstName(firstName) {
    return (dispatch) => {
        const error = Validation.validateFieldIsRequired(firstName)
            || Validation.validateEnglishCharacters(firstName);

        dispatch(updateFirstName(firstName));
        dispatch(updateError(error, "firstName"));
    };
}

export function validateAndUpdateLastName(lastName) {
    return (dispatch) => {
        const error = Validation.validateFieldIsRequired(lastName)
            || Validation.validateEnglishCharacters(lastName);

        dispatch(updateLastName(lastName));
        dispatch(updateError(error, "lastName"));
    };
}

export function updateFirstName(firstName) {
    return {
        type: SHIPPING_ADDRESS_FORM_UPDATE_FIRST_NAME,
        firstName
    };
}

export function updateLastName(lastName) {
    return {
        type: SHIPPING_ADDRESS_FORM_UPDATE_LAST_NAME,
        lastName
    };
}

export function updateAddressLine2(addressLine2) {
    return {
        type: SHIPPING_ADDRESS_FORM_UPDATE_LINE_2,
        addressLine2
    };
}

export function updateAddressLine1(addressLine1, { validateCountry = false } = {}) {
    return (dispatch, getState) => {
        if (validateCountry && !getState().shippingAddressForm.country) {
            dispatch(updateError({
                message: "Please choose country first"
            }, "country"));
        }

        dispatch({
            type: SHIPPING_ADDRESS_FORM_UPDATE_LINE_1,
            addressLine1
        });
    };
}

export function updateCountry(country, { resetOtherField } = {}) {
    if (resetOtherField) {
        return {
            type: SHIPPING_ADDRESS_FORM_UPDATE_COUNTRY_AND_RESET,
            country
        };
    }

    return {
        type: SHIPPING_ADDRESS_FORM_UPDATE_COUNTRY,
        country
    };
}

export function updateState(state) {
    return {
        type: SHIPPING_ADDRESS_FORM_UPDATE_STATE,
        state
    };
}

export function updatePostalCode(postalCode) {
    return {
        type: SHIPPING_ADDRESS_FORM_UPDATE_POSTALCODE,
        postalCode
    };
}

export function updateCity(city) {
    return {
        type: SHIPPING_ADDRESS_FORM_UPDATE_CITY,
        city
    };
}

export function updateShowModal(showModal) {
    return {
        type: SHIPPING_ADDRESS_FORM_UPDATE_SHOW_MODAL,
        showModal
    };
}

export function updateAddress({
    addressLine1,
    addressLine2,
    city,
    state,
    postalCode
}) {
    return {
        type: SHIPPING_ADDRESS_FORM_UPDATE_ADDRESS,
        addressLine1,
        addressLine2,
        city,
        state,
        postalCode
    };
}

export function showError(error) {
    return {
        type: SHIPPING_ADDRESS_FORM_SHOW_ERROR,
        error
    };
}

export function clearAddressLine1Error() {
    return (dispatch) => {
        dispatch(updateError(null, "addressLine1"));
    };
}

export function clearError(errorType) {
    return {
        type: SHIPPING_ADDRESS_FORM_CLEAR_ERROR,
        errorType
    };
}

export function clearSubscriptionFormError(errorType) {
    return {
        type: SUBSCRIPTION_FORM_CLEAR_ERROR,
        errorType
    };
}

export function setDefaultCountry() {
    return (dispatch, getState) => {
        const {
            country,
            shippingAddressForm: {
                country: shippingCountry
            }
        } = getState();

        if (country && !shippingCountry) {
            dispatch(updateCountry(country));
        }
    };
}

export default {
    updateCountry,
    updateState,
    updatePostalCode,
    updateFirstName,
    updateLastName,
    updateAddressLine1,
    updateAddressLine2,
    updateCity,
    updateShowModal,
    updateAddress,
    updateError,
    showError,
    clearError,
    clearAddressLine1Error,
    validateShippingAddress,
    validateShippingAddressForSubscription,
    validateAddressLine1,
    validateAndUpdateCountry,
    validateAndUpdateState,
    validateAndUpdateCity,
    validateAndUpdatePostalCode,
    validateAndUpdateAddressLine1,
    validateAndUpdateAddressLine2,
    validateAndUpdateFirstName,
    validateAndUpdateLastName,
    verifyAddress,
    setDefaultCountry
};
